/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/30/2018
 * Copyright All Rights Reserved
 */

import 'src/scss/app.scss';
import Amplify from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
import store from 'store/';
import Root from 'components/Root';
import config, {
  initializeConfigs,
  AWS_REGION,
  COGNITO_USER_POOL_ID,
  COGNITO_WEB_CLIENT_ID,
  ENVIRONMENT,
  ROLLBAR_ACCESS_TOKEN,
  ROLLBAR_ENABLED,
} from 'support/config';
import rollbarInit from 'support/rollbarInit';

initializeConfigs().then(() => {
  rollbarInit(config(ROLLBAR_ENABLED), config(ENVIRONMENT), config(ROLLBAR_ACCESS_TOKEN));

  Amplify.configure({
    Auth: {
      region: config(AWS_REGION),
      userPoolId: config(COGNITO_USER_POOL_ID),
      userPoolWebClientId: config(COGNITO_WEB_CLIENT_ID),
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
  });

  const render = (Component) => {
    const root = document.getElementById('root');
    if (root !== null) {
      ReactDOM.render(
        <Component store={store} />,
        root
      );
    }
  };

  render(Root);

  // If hot module replacement is enabled in development
  if (module.hot) {
    // When an update to the app is available
    module.hot.accept('components/Root', () => {
      // Render the updated app
      render(Root);
    });
  }
});



// WEBPACK FOOTER //
// ./js/app.jsx